// @ts-nocheck

const CTR_MM_V2_TRAP_OWNER = "ctr-mobile-menu-v2";
const FOCUS_TRAP_REGISTRY_KEY = "__exaltActiveFocusTrap";

/** @type {Record<string, (event: Event) => void>} */
const ctrMmV2FocusHandlers = {};

function ctrMmV2GetRegisteredTrap() {
  return document[FOCUS_TRAP_REGISTRY_KEY];
}

function ctrMmV2RegisterTrap(remove) {
  document[FOCUS_TRAP_REGISTRY_KEY] = { owner: CTR_MM_V2_TRAP_OWNER, remove };
}

function ctrMmV2UnregisterTrap() {
  const registered = ctrMmV2GetRegisteredTrap();
  if (registered?.owner === CTR_MM_V2_TRAP_OWNER) {
    delete document[FOCUS_TRAP_REGISTRY_KEY];
  }
}

function ctrMmV2RemoveRegisteredTrapIfNeeded() {
  const registered = ctrMmV2GetRegisteredTrap();
  if (
    registered &&
    registered.owner !== CTR_MM_V2_TRAP_OWNER &&
    typeof registered.remove === "function"
  ) {
    registered.remove();
  }
}

/**
 * @param {HTMLElement} container
 * @returns {HTMLElement[]}
 */
function ctrMmV2GetFocusable(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled"
    )
  ).filter(
    (el) =>
      el instanceof HTMLElement &&
      !el.hasAttribute("disabled") &&
      el.getAttribute("aria-disabled") !== "true"
  );
}

/**
 * @param {HTMLElement} container
 */
function ctrMmV2TrapFocus(container) {
  ctrMmV2RemoveRegisteredTrapIfNeeded();
  ctrMmV2RemoveTrapFocus();

  const focusable = ctrMmV2GetFocusable(container);
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  ctrMmV2FocusHandlers.keydown = (event) => {
    if (!(event instanceof KeyboardEvent) || event.key !== "Tab") return;

    const activeEl = document.activeElement;

    if (!event.shiftKey && activeEl === last) {
      event.preventDefault();
      first.focus();
    } else if (
      event.shiftKey &&
      (activeEl === first || activeEl === container)
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  ctrMmV2FocusHandlers.focusin = (event) => {
    if (
      event.target instanceof Node &&
      !container.contains(event.target)
    ) {
      if (document.activeElement === first) return;
      event.stopPropagation();
      first.focus();
    }
  };

  document.addEventListener("keydown", ctrMmV2FocusHandlers.keydown, true);
  document.addEventListener("focusin", ctrMmV2FocusHandlers.focusin, true);
  ctrMmV2RegisterTrap(ctrMmV2RemoveTrapFocus);
  first.focus();
}

function ctrMmV2RemoveTrapFocus() {
  if (ctrMmV2FocusHandlers.keydown) {
    document.removeEventListener(
      "keydown",
      ctrMmV2FocusHandlers.keydown,
      true
    );
  }
  if (ctrMmV2FocusHandlers.focusin) {
    document.removeEventListener(
      "focusin",
      ctrMmV2FocusHandlers.focusin,
      true
    );
  }
  ctrMmV2FocusHandlers.keydown = undefined;
  ctrMmV2FocusHandlers.focusin = undefined;
  ctrMmV2UnregisterTrap();
}

document.addEventListener("alpine:init", () => {
  Alpine.data("ctrMobileMenuV2", function () {
    return {
      isOpen: false,
      openParent: null,
      openSubmenu: null,
      _lastFocus: null,

      init() {
        const previewEnable =
          this.$el.dataset.previewEnable === "true" ||
          this.$el.dataset.previewEnable === true;

        if (previewEnable) {
          document.body.classList.add("mobile-menu-v2");
        }

        this.$refs.drawer?.addEventListener("click", (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          const link = target.closest("a[href]");
          if (!link) return;
          const href = link.getAttribute("href");
          if (!href || href === "#" || href.startsWith("javascript:")) return;
          this.close();
        });

        this._bindLegacyTrigger();
        this._bindThemeEditor();
      },

      _bindThemeEditor() {
        if (typeof Shopify === "undefined" || !Shopify.designMode) return;

        const isOurs = (target) => {
          if (!(target instanceof Element)) return false;
          return (
            target === this.$el ||
            target.contains(this.$el) ||
            this.$el.contains(target)
          );
        };

        const expandFor = (target) => {
          if (!(target instanceof Element)) return;

          const parent = target.closest(".ctr-mm-v2__parent");
          if (parent && parent.dataset.parentId) {
            this.openParent = parent.dataset.parentId;
          }

          const childMenu = target.closest(".ctr-mm-v2__child-item--menu");
          if (childMenu) {
            const grandchildren = childMenu.querySelector(
              ".ctr-mm-v2__grandchildren"
            );
            if (grandchildren && grandchildren.id) {
              this.openSubmenu = grandchildren.id.replace(
                "ctr-mm-v2-submenu-",
                ""
              );
            }
          }
        };

        const onSelect = (event) => {
          if (!isOurs(event.target)) {
            if (this.isOpen) this.close();
            return;
          }
          if (!this.isOpen) this.open();
          expandFor(event.target);
        };

        const onDeselect = (event) => {
          if (!isOurs(event.target)) return;
          if (this.isOpen) this.close();
        };

        document.addEventListener("shopify:section:select", onSelect);
        document.addEventListener("shopify:section:load", onSelect);
        document.addEventListener("shopify:block:select", onSelect);
        document.addEventListener("shopify:section:deselect", onDeselect);
      },

      _bindLegacyTrigger() {
        const summaries = document.querySelectorAll(
          ".header__drawer--mobile .header__icon--menu.header__icon--summary"
        );

        summaries.forEach((summary) => {
          if (summary.dataset.ctrMmV2Bound === "true") return;
          summary.dataset.ctrMmV2Bound = "true";

          summary.addEventListener(
            "click",
            (event) => {
              if (!document.body.classList.contains("mobile-menu-v2")) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              this.toggle();
            },
            true
          );
        });
      },

      toggle() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      },

      open() {
        this._lastFocus = document.activeElement;
        this.isOpen = true;
        document.documentElement.setAttribute("scroll-lock", "");
        this.$nextTick(() => {
          if (this.$refs.drawer instanceof HTMLElement) {
            ctrMmV2TrapFocus(this.$refs.drawer);
          }
        });
      },

      close() {
        this.isOpen = false;
        this.openParent = null;
        this.openSubmenu = null;
        document.documentElement.removeAttribute("scroll-lock");
        ctrMmV2RemoveTrapFocus();
        if (this._lastFocus instanceof HTMLElement) {
          this._lastFocus.focus();
        }
      },

      /**
       * @param {string} parentId
       */
      toggleParent(parentId) {
        this.openParent = this.openParent === parentId ? null : parentId;
        this.openSubmenu = null;
      },

      /**
       * @param {string} submenuId
       */
      toggleSubmenu(submenuId) {
        this.openSubmenu = this.openSubmenu === submenuId ? null : submenuId;
      },
    };
  });
});
